import { useState, useRef, useEffect } from "react";
import { Loader } from "../../inc/Fetch";

const SearchUI = ({ data, plugin, searchPluginInstance }) => {
    
    const lastKeywordRef = useRef("");
    const [keyword, setKeyword] = useState("");
    const [results, setResults] = useState([]);
    const [currentResult, setCurrentResult] = useState(0);
    
    const handleKeyDown = (e) => {
        if (e.key !== "Enter") return;

        if (e.shiftKey) {
            prevMatch();
            return;
        }

        if (lastKeywordRef.current !== keyword) {
            lastKeywordRef.current = keyword;
            runSearch();
        } else {
            nextMatch();
        }
    };


    
    const runSearch = () => {
        const cleanInput = keyword.trim().replace(/\s+/g, '').replace(/([ً-ْ])/g, '');
        const flippedKeyword = cleanInput
        .replace(/([ً-ْ])/g, '')
        .split('')
        .reverse()
        .join('');

        const found = [];

        searchPluginInstance.highlight(flippedKeyword);

        data.forEach((page) => {
            
            page.text = page.text.trim().replace(/([ً-ْ])/g, '').replace(/\s+/g, '');
            if (page.text.includes(flippedKeyword)) {

                found.push(page.pageIndex);
            }
        });

        // console.log(found);
        
        
        setResults(found);
        setCurrentResult(0);

        if (found.length > 0) {
            plugin.jumpToPage && plugin.jumpToPage(found[0]);
            // searchPluginInstance?.jumpToNextMatch();

        }
    };

    const nextMatch = () => {
        if (!results.length) return;

        const next = (currentResult + 1) % results.length;
        setCurrentResult(next);
        plugin.jumpToPage && plugin.jumpToPage(results[next]);
        // searchPluginInstance?.jumpToNextMatch();
    };

    // Navigate previous
    const prevMatch = () => {
        if (!results.length) return;

        const prev =
            (currentResult - 1 + results.length) % results.length;

        setCurrentResult(prev);
        plugin.jumpToPage && plugin.jumpToPage(results[prev]);
    };

    
    if (!data?.length) return <Loader />;

    return (
        <div className="searchBookBox">
            <input
                type="search"
                placeholder="ابحث في الكتاب..."
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={handleKeyDown}
                style={{
                    padding: 6,
                    width: 250,
                    direction: "rtl",
                }}
            />
        </div>
    );
};

export default SearchUI;